(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["dropdown~index~input~input-number~loading~menu~modal~popconfirm~popover~select~slider~table~tag~time~3dc0bd12"],{

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue-ref/index.js
var vue_ref = __webpack_require__(24);
var vue_ref_default = /*#__PURE__*/__webpack_require__.n(vue_ref);

// CONCATENATED MODULE: ./src/directives/inputDirective.js
/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;

function makeMap(str, expectsLowerCase) {
  var map = Object.create(null);
  var list = str.split(',');

  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }

  return expectsLowerCase ? function (val) {
    return map[val.toLowerCase()];
  } : function (val) {
    return map[val];
  };
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

function onCompositionStart(e) {
  e.target.composing = true;
}

function onCompositionEnd(e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) return;
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}
/* istanbul ignore if */


if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;

    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

function antInput(Vue) {
  return Vue.directive('meg-input', {
    inserted: function inserted(el, binding, vnode) {
      if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
        if (!binding.modifiers || !binding.modifiers.lazy) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd); // Safari < 10.2 & UIWebView doesn't fire compositionend when
          // switching focus before confirming composition choice
          // this also fixes the issue where some browsers e.g. iOS Chrome
          // fires "change" instead of "input" on autocomplete.

          el.addEventListener('change', onCompositionEnd);
          /* istanbul ignore if */

          if (isIE9) {
            el.vmodel = true;
          }
        }
      }
    }
  });
}
/* harmony default export */ var inputDirective = ({
  install: function install(Vue) {
    antInput(Vue);
  }
});
// CONCATENATED MODULE: ./src/directives/portalDirective.js
function antPortal(Vue) {
  return Vue.directive('meg-portal', {
    inserted: function inserted(el, binding) {
      var value = binding.value;
      var parentNode = typeof value === 'function' ? value(el) : value;

      if (parentNode !== el.parentNode) {
        parentNode.appendChild(el);
      }
    },
    componentUpdated: function componentUpdated(el, binding) {
      var value = binding.value;
      var parentNode = typeof value === 'function' ? value(el) : value;

      if (parentNode !== el.parentNode) {
        parentNode.appendChild(el);
      }
    }
  });
}
/* harmony default export */ var portalDirective = ({
  install: function install(Vue) {
    antPortal(Vue);
  }
});
// CONCATENATED MODULE: ./src/directives/tableSticky.js
var tableStickyObj = {};
window._MegUISticky = tableStickyObj;
var __STICKY_TABLE = {
  // 给固定头设置样式
  doFix: function doFix(dom, top, data) {
    var uid = data.uid,
        domType = data.domType,
        isExist = data.isExist;
    var uObj = tableStickyObj[uid];
    var curObj = uObj[domType];
    var headerRect = tableStickyObj[uid].headerRect;
    var left = tableStickyObj[uid][domType].left;

    if (!isExist) {
      dom.style.position = 'fixed';
      dom.style.zIndex = '2001';
      dom.style.top = top + 'px';
    }

    uObj.tableWrapDom.style.marginTop = headerRect.height + 'px';

    if (domType === 'fixed') {
      dom.style.left = curObj.left + 'px';
      curObj.bodyDom.style.paddingTop = headerRect.height + 'px';
      curObj.bodyDom.children[0].style.marginRight = -6 + 'px';
    } else if (domType === 'fixedRight') {
      dom.style.left = curObj.left + 1 + 'px';
      curObj.bodyDom.style.paddingTop = headerRect.height + 'px';
    } else if (domType === 'mainBody') {
      curObj.headerDom.style.overflow = 'hidden';
      curObj.headerDom.style.marginBottom = '0px';
    }
  },
  // 给固定头取消样式
  removeFix: function removeFix(dom, data) {
    var uid = data.uid,
        domType = data.domType;
    var uObj = tableStickyObj[uid];
    var curObj = uObj[domType];
    dom.style.position = 'static';
    dom.style.top = '0';
    dom.style.zIndex = '0';
    uObj.tableWrapDom.style.marginTop = '0';
    uObj.tableWrapDom.style.paddingTop = '0';

    if (domType === 'fixed') {
      curObj.dom.style.position = 'absolute';
      curObj.dom.style.top = '0';
      curObj.bodyDom.style.paddingTop = '0';
    } else if (domType === 'fixedRight') {
      curObj.dom.style.position = 'absolute';
      curObj.dom.style.top = '0';
      curObj.bodyDom.style.paddingTop = '0';
    }
  },
  // 给固定头添加class
  addClass: function addClass(dom, fixtop, data) {
    fixtop = fixtop || 0;
    var isExist = dom.classList.contains('fixed');
    data.isExist = !!isExist;

    if (!isExist) {
      // 若有，就不再添加
      dom.classList.add('fixed');
    }

    this.doFix(dom, fixtop, data);
  },
  // 给固定头移除class
  removeClass: function removeClass(dom, data) {
    if (dom.classList.contains('fixed')) {
      dom.classList.remove('fixed');
      this.removeFix(dom, data);
    }
  },

  /**
   * 计算某元素距离相对父元素的top距离
   * @param {Nodes} e 某元素
   * @param {String} domId 父元素id
   * @param {Boolean} isParent 是否父元素
   * @returns {Number}
   */
  getPosY: function getPosY(el, domId) {
    var offset = 0;
    var pDom = el.offsetParent;

    if (pDom != null && '#' + el.id !== domId) {
      offset = el.offsetTop;
      offset += this.getPosY(pDom, domId);
    }

    return offset;
  },
  // 获取元素的横坐标（相对于窗口）
  getPosX: function getPosX(e) {
    var offset = e.offsetLeft;
    if (e.offsetParent != null) offset += this.getPosX(e.offsetParent);
    return offset;
  },
  fixHead: function fixHead(scrollDom, el, uid, binding, eventType) {
    this.fixHead1(this, {
      scrollDom: scrollDom,
      el: el,
      uid: uid,
      binding: binding,
      eventType: eventType
    });
  },
  // 具体判断是否固定头的主函数
  fixHead1: sticky_throttle(function (_this, _ref) {
    var scrollDom = _ref.scrollDom,
        el = _ref.el,
        uid = _ref.uid,
        binding = _ref.binding,
        eventType = _ref.eventType;
    var top = binding.value.top; // 表头DOM节点

    var headerWrapDom = el.children[0].children[0].children[0];
    var headerTop = tableStickyObj[uid].headerRect.top - top;
    var scrollTop = scrollDom.scrollTop;
    var fixedHeadDom = tableStickyObj[uid].fixed.headerDom;
    var fixedHeadRightDom = tableStickyObj[uid].fixedRight.headerDom; // eslint-disable-next-line radix

    var bodyDomHeight = parseInt(tableStickyObj[uid].mainBody.bodyDomHeight) + tableStickyObj[uid].headerRect.height;

    if (scrollTop < headerTop || scrollTop - headerTop > bodyDomHeight) {
      _this.removeClass(headerWrapDom, {
        domType: 'mainBody',
        uid: uid
      });

      fixedHeadDom && _this.removeClass(fixedHeadDom, {
        domType: 'fixed',
        uid: uid
      });
      fixedHeadRightDom && _this.removeClass(fixedHeadRightDom, {
        domType: 'fixedRight',
        uid: uid
      });
    } else {
      var fixtop = top + scrollDom.getBoundingClientRect().top; // 如果表头滚动到 父容器顶部了。fixed定位

      _this.addClass(headerWrapDom, fixtop, {
        domType: 'mainBody',
        uid: uid
      });

      fixedHeadDom && _this.addClass(fixedHeadDom, fixtop, {
        domType: 'fixed',
        uid: uid
      });
      fixedHeadRightDom && _this.addClass(fixedHeadRightDom, fixtop, {
        domType: 'fixedRight',
        uid: uid
      });
    }
  }, 100, {
    eventType: 'fixHead111'
  }),
  //
  setHeadWidth: function setHeadWidth(data) {
    this.setHeadWidth1(this, data);
  },
  // 设置头部固定时表头外容器的宽度写死为表格body的宽度
  setHeadWidth1: sticky_debounce(function (_this, data) {
    var el = data.el,
        uid = data.uid,
        binding = data.binding,
        eventType = data.eventType;
    var scrollDom = tableStickyObj[uid].scrollDom;
    var headerWrapDom = el.children[0].children[0].children[0]; // el-table__header-wrapper

    var fixedHeadDom = tableStickyObj[uid].fixed.headerDom;
    var fixedHeadRightDom = tableStickyObj[uid].fixedRight.headerDom;
    var headerH = headerWrapDom.offsetHeight;
    var headerW = headerWrapDom.offsetWidth;

    var distTop = _this.getPosY(headerWrapDom, binding.value.parent);

    var scrollDistTop = _this.getPosY(scrollDom); // 滚动条距离顶部的距离


    if (tableStickyObj[uid].isFirst) {
      tableStickyObj[uid].headerRect.distTop = distTop;
      tableStickyObj[uid].headerRect.scrollDistTop = scrollDistTop;
      tableStickyObj[uid].isFirst = false;
    }

    tableStickyObj[uid].headerRect.top = tableStickyObj[uid].headerRect.distTop - tableStickyObj[uid].headerRect.scrollDistTop; // 表头距离顶部的距离 - 滚动条距离顶部的距离

    tableStickyObj[uid].headerRect.height = headerH;
    tableStickyObj[uid].headerRect.width = headerW; // 确保每次刷新，只获取一次

    tableStickyObj[uid].mainBody.dom = el.children[0].children[0];
    tableStickyObj[uid].mainBody.headerDom = headerWrapDom;
    tableStickyObj[uid].mainBody.bodyDom = el.children[0].children[0].children[1];
    tableStickyObj[uid].mainBody.headerDomWidth = getComputedStyle(el.children[0].children[0].children[1]).width;
    tableStickyObj[uid].mainBody.bodyDomHeight = getComputedStyle(el.children[0].children[0].children[1]).height;
    tableStickyObj[uid].mainBody.left = 0;

    _this.initFixedWrap({
      el: el,
      uid: uid,
      eventType: eventType,
      key: 'fixed',
      className: 'meg-table-fixed-left',
      className1: 'meg-table-header',
      className2: 'meg-table-body-outer'
    });

    _this.initFixedWrap({
      el: el,
      uid: uid,
      eventType: eventType,
      key: 'fixedRight',
      className: 'meg-table-fixed-right',
      className1: 'meg-table-header',
      className2: 'meg-table-body-outer'
    }); // 获取到当前表格个表格body的宽度


    var bodyWrapperDom = el.getElementsByClassName('meg-table-body')[0];
    var width = getComputedStyle(bodyWrapperDom).width; // 给表格设置宽度。这里默认一个页面中的多个表格宽度是一样的。所以直接遍历赋值，也可以根据自己需求，单独设置

    var tableParent = el.getElementsByClassName('meg-table-header');
    tableParent[0].style.width = width;

    if (fixedHeadDom) {
      tableStickyObj[uid].fixed.headDom && (tableStickyObj[uid].fixed.headDom.style.width = tableStickyObj[uid].fixed.headerDomWidth);
      tableStickyObj[uid].fixed.bodyDom && (tableStickyObj[uid].fixed.bodyDom.style.width = tableStickyObj[uid].fixed.headerDomWidth);
    }

    if (fixedHeadRightDom) {
      tableStickyObj[uid].fixedRight.headDom && (tableStickyObj[uid].fixedRight.headDom.style.width = tableStickyObj[uid].fixedRight.headerDomWidth);
      tableStickyObj[uid].fixedRight.bodyDom && (tableStickyObj[uid].fixedRight.bodyDom.style.width = tableStickyObj[uid].fixedRight.headerDomWidth);
    }

    _this.fixHead(scrollDom, el, uid, binding, eventType); // 判断顶部是否已吸顶的一个过程

  }),
  initFixedWrap: function initFixedWrap(data) {
    var key = data.key,
        el = data.el,
        eventType = data.eventType,
        className = data.className,
        className1 = data.className1,
        className2 = data.className2,
        uid = data.uid; // 确保每次刷新，只获取一次

    if (eventType === 'resize' || !tableStickyObj[uid][key].dom) {
      var tableFixedDom = el.getElementsByClassName(className);

      if (tableFixedDom.length) {
        var fixedDom = tableFixedDom[0];
        var arr = fixedDom.getElementsByClassName(className1); //

        var arrOuter = fixedDom.getElementsByClassName(className2); //

        var headW = getComputedStyle(fixedDom).width;
        tableStickyObj[uid][key].dom = fixedDom;

        if (arr.length) {
          var distLeft = this.getPosX(fixedDom); // 距离窗口左侧的距离

          var headDom = arr[0];
          headDom.style.width = headW;
          tableStickyObj[uid][key].left = distLeft; // 距离窗口左边像素

          if (key === 'fixedRight') {
            // right-fixed 的特别之处
            headDom.classList.add('scroll-bar-h0');
            tableStickyObj[uid][key].bodyDom = arrOuter[0];
            headDom.style.overflow = 'auto';
            headDom.scrollLeft = headDom.scrollWidth;
            headDom.style.overflow = 'hidden'; // 设置了滚动到最后，设置不可滚动
          } else {
            headDom.style.overflow = 'hidden';
            tableStickyObj[uid][key].bodyDom = arrOuter[0];
          }

          tableStickyObj[uid][key].headerDom = headDom; // 取第一个

          tableStickyObj[uid][key].headerDomWidth = headDom.getBoundingClientRect().width;
        }
      }
    }
  },
  // 监听父级的某些变量（父级一定要有才能被监听到）
  watched: function watched(_ref2) {
    var _this2 = this;

    var el = _ref2.el,
        binding = _ref2.binding,
        vnode = _ref2.vnode,
        uid = _ref2.uid;
    // 监听左侧导航栏是否折叠
    vnode.context.$watch('isNavFold', function (val) {
      vnode.context.$nextTick(function () {
        setTimeout(function () {
          _this2.setHeadWidth({
            el: el,
            uid: uid,
            binding: binding,
            eventType: 'resize'
          });
        }, 200);
      });
    });
  }
};
/**
 * 节流函数: 指定时间间隔内只会执行一次任务
 * @param {function} fn
 * @param {Number} interval
 */
// eslint-disable-next-line camelcase

function sticky_throttle(fn) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var canRun = true;
  return function () {
    var _arguments = arguments,
        _this3 = this;

    if (!canRun) return;
    canRun = false;
    setTimeout(function () {
      fn.apply(_this3, _arguments);
      canRun = true;
    }, interval);
  };
} // eslint-disable-next-line camelcase


function sticky_debounce(fn, delay, config) {
  var _delay = delay || 200;

  config = config || {};
  return function () {
    var th = this;
    var args = arguments;

    if (fn.timer) {
      clearTimeout(fn.timer);
      fn.timer = null;
    } else {// fn.debounceNum = debounceNum
    }

    fn.timer = setTimeout(function () {
      fn.timer = null;
      fn.apply(th, args);
    }, _delay);
  };
} // 全局注册 自定义事件


function tableSticky(Vue) {
  return Vue.directive('meg-sticky', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function inserted(el, binding, vnode) {
      // 获取当前vueComponent的ID。作为存放各种监听事件的key
      var uid = vnode.context._uid;
      var top = binding.value.top; // 获取当前滚动的容器是什么。如果是document滚动。则可默认不传入parent参数

      var scrollDom = document.querySelector(binding.value.parent) || document.body;

      if (!tableStickyObj[uid]) {
        tableStickyObj[uid] = {
          uid: uid,
          isFirst: true,
          fixFunObj: {},
          // 用于存放滚动容器的监听scroll事件
          setWidthFunObj: {},
          // 用于存放页面resize后重新计算head宽度事件
          autoMoveFunObj: {},
          // 用户存放如果是DOM元素内局部滚动时，document滚动时，fix布局的表头也需要跟着document一起向上滚动
          scrollDomRect: {},
          headerRect: {
            top: 0,
            left: 0,
            parentTop: top
          },
          mainBody: {},
          // 表格主体
          fixed: {},
          // 表格左浮动
          fixedRight: {},
          // 表格右浮动
          // binding,
          // el,
          //   tableWrapDom: el.getElementsByClassName('el-table__body-wrapper')[0],
          tableWrapDom: el.getElementsByClassName('meg-table-body')[0],
          scrollDom: scrollDom
        };
      }

      __STICKY_TABLE.watched({
        el: el,
        binding: binding,
        vnode: vnode,
        uid: uid
      }); // 监听父级的某些变量
      // 当window resize时 重新计算设置表头宽度，并将监听函数存入 监听函数对象中，方便移除监听事件


      window.addEventListener('resize', tableStickyObj[uid].setWidthFunObj = function () {
        __STICKY_TABLE.setHeadWidth({
          el: el,
          uid: uid,
          binding: binding,
          eventType: 'resize'
        }); // 首先设置表头宽度

      });
      window.dispatchEvent(new Event('resize')); // 给滚动容器加scroll监听事件。并将监听函数存入 监听函数对象中，方便移除监听事件

      scrollDom.addEventListener('scroll', tableStickyObj[uid].fixFunObj = function (e) {
        __STICKY_TABLE.fixHead(scrollDom, el, uid, binding, 'scroll');
      });
    },
    // component 更新后。重新计算表头宽度
    componentUpdated: function componentUpdated(el, binding, vnode) {
      var uid = vnode.context._uid;

      __STICKY_TABLE.setHeadWidth({
        el: el,
        uid: uid,
        binding: binding,
        eventType: 'componentUpdated'
      });
    },
    // 节点取消绑定时 移除各项监听事件。
    unbind: function unbind(el, binding, vnode) {
      var uid = vnode.context._uid;
      window.removeEventListener('resize', tableStickyObj[uid].setWidthFunObj);
      var scrollDom = document.querySelector(binding.value.parent) || document;
      scrollDom.removeEventListener('scroll', tableStickyObj[uid].fixFunObj);

      if (binding.value.parent) {
        document.removeEventListener('scroll', tableStickyObj[uid].autoMoveFunObj);
      }

      delete tableStickyObj[uid];
    }
  });
}
/* harmony default export */ var directives_tableSticky = ({
  install: function install(Vue) {
    tableSticky(Vue);
  }
});
// CONCATENATED MODULE: ./src/directives/index.js

 // import { antDecorator } from './FormDecoratorDirective';



/* harmony default export */ var directives = __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.use(vue_ref_default.a, {
      name: 'meg-ref'
    });
    antInput(Vue);
    tableSticky(Vue); // antDecorator(Vue);

    antPortal(Vue);
  }
});

/***/ })

}]);